import React from 'react';
const IconX = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.0346 6.24949C14.7937 3.00858 9.49044 3.00858 6.24953 6.24949C3.00863 9.49039 3.00863 14.7937 6.24953 18.0346C9.49044 21.2755 14.7937 21.2755 18.0346 18.0346C21.2756 14.7937 21.2756 9.49039 18.0346 6.24949ZM14.4991 15.6776L12.1421 13.3206L9.78507 15.6776L8.60656 14.4991L10.9636 12.142L8.60656 9.78502L9.78507 8.60651L12.1421 10.9635L14.4991 8.60651L15.6776 9.78502L13.3206 12.142L15.6776 14.4991L14.4991 15.6776Z" fill="#999999"/>
</svg>
);
};
export default IconX;